import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITemplate } from '../../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class AddWidgetDialogService extends BaseService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  getTemplates(): Observable<ITemplate[]> {
    const url = 'Widgets/GetTemplates_WoutImg';
    return this.get(url, {});
  }

  getTemplateImage(id: number): Observable<string> {
    const url = 'Widgets/GetTemplates_WImg';
    return this.get(url, {
      id: id
    });
  }
}
